(() => {
  const VERSION = '1.1';
  const PANEL_SELECTOR = '[data-egifts-cart-same-design]';
  const MOBILE_QUERY = '(max-width: 749px)';
  const STRIPE_STYLE_ID = 'egifts-cart-visible-row-stripes';
  const STRIPE_PLAIN_CLASS = 'egifts-cart-row--plain';
  const STRIPE_SHADE_CLASS = 'egifts-cart-row--shade';

  if (window.EgiftsCartUxOrderV1) {
    window.EgiftsCartUxOrderV1.applyAll();
    return;
  }

  const media = window.matchMedia(MOBILE_QUERY);
  let scheduled = false;
  let observer = null;

  const installStripeStyles = () => {
    if (document.getElementById(STRIPE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STRIPE_STYLE_ID;
    style.textContent = `
      #main-cart-items tbody > tr.cart-item.${STRIPE_PLAIN_CLASS},
      #main-cart-items tbody > tr.cart-item.${STRIPE_PLAIN_CLASS} > td,
      #main-cart-items tbody > tr.cart-item.${STRIPE_PLAIN_CLASS} .cart-item__details,
      #main-cart-items tbody > tr.cart-item.${STRIPE_PLAIN_CLASS} .cart-item__quantity,
      #main-cart-items tbody > tr.cart-item.${STRIPE_PLAIN_CLASS} .cart-item__totals {
        background: #fff !important;
      }

      #main-cart-items tbody > tr.cart-item.${STRIPE_SHADE_CLASS},
      #main-cart-items tbody > tr.cart-item.${STRIPE_SHADE_CLASS} > td,
      #main-cart-items tbody > tr.cart-item.${STRIPE_SHADE_CLASS} .cart-item__details,
      #main-cart-items tbody > tr.cart-item.${STRIPE_SHADE_CLASS} .cart-item__quantity,
      #main-cart-items tbody > tr.cart-item.${STRIPE_SHADE_CLASS} .cart-item__totals {
        background: #f8f8f8 !important;
      }
    `;

    document.head.append(style);
  };

  const stripeVisibleProductRows = () => {
    document.querySelectorAll('#main-cart-items tbody').forEach((tbody) => {
      const allRows = Array.from(tbody.querySelectorAll(':scope > tr.cart-item'));

      allRows.forEach((row) => {
        row.classList.remove(STRIPE_PLAIN_CLASS, STRIPE_SHADE_CLASS);
      });

      const visibleProductRows = allRows.filter(
        (row) =>
          !row.classList.contains('egifts-customily-addon-source-row') &&
          row.getAttribute('aria-hidden') !== 'true' &&
          !row.hidden
      );

      visibleProductRows.forEach((row, index) => {
        row.classList.add(index % 2 === 0 ? STRIPE_PLAIN_CLASS : STRIPE_SHADE_CLASS);
      });
    });
  };

  const clearMobilePanelPosition = (panel) => {
    panel.style.removeProperty('width');
    panel.style.removeProperty('max-width');
    panel.style.removeProperty('margin-left');
  };

  const alignMobilePanel = (panel) => {
    panel.style.setProperty('width', 'calc(100vw - 2rem)', 'important');
    panel.style.setProperty('max-width', 'calc(100vw - 2rem)', 'important');
    panel.style.setProperty('margin-left', '0px', 'important');

    const left = panel.getBoundingClientRect().left;
    const desiredLeft = 16;
    const shift = Math.round(desiredLeft - left);

    panel.style.setProperty('margin-left', `${shift}px`, 'important');
  };

  const placePanel = (panel) => {
    const row = panel.closest('.cart-item');
    if (!row) return;

    const details = row.querySelector('.cart-item__details');
    const quantityCell = row.querySelector('.cart-item__quantity');

    if (!details || !quantityCell) return;

    if (media.matches) {
      if (panel.parentElement !== quantityCell) {
        quantityCell.append(panel);
      }

      alignMobilePanel(panel);
      return;
    }

    clearMobilePanelPosition(panel);

    /*
      Na desktopie panel ma być ostatnim elementem szczegółów produktu.
      Dzięki temu elementy Teeinblue, np. "Zobacz personalizację",
      które pojawiają się asynchronicznie, pozostają NAD sekcją
      "Dodaj ten sam wzór".
    */
    if (panel.parentElement !== details || panel !== details.lastElementChild) {
      details.append(panel);
    }
  };

  const applyAll = () => {
    document.querySelectorAll(PANEL_SELECTOR).forEach(placePanel);
    stripeVisibleProductRows();
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  };

  const installObserver = () => {
    if (observer) return;

    const root = document.querySelector('cart-items') || document.body;
    if (!root) return;

    observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true
    });
  };

  const init = () => {
    installStripeStyles();
    applyAll();
    installObserver();

    [150, 400, 900, 1600, 3000].forEach((delay) => {
      window.setTimeout(schedule, delay);
    });
  };

  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', schedule);
  } else if (typeof media.addListener === 'function') {
    media.addListener(schedule);
  }

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify-event-cart-ajax', schedule);
  document.addEventListener('shopify-event-cart-modified', schedule);
  document.addEventListener('teeinblue-event-after-cart-added', schedule);
  document.addEventListener('egifts:g-promo-synced', schedule);

  window.EgiftsCartUxOrderV1 = {
    version: VERSION,
    applyAll: schedule
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();